import axios from "axios";
import {PaginateModel} from "../../../models/PaginateModel";
import {ADMIN_GET_CONSIGN_PRODUCTS_ENDPOINT, ADMIN_IMPORT_REQUEST_ENDPOINT} from "../../../constants/endpoints";
import { ImportRequestModel, SearchModel } from "../../../models/ImportRequestModel";
import { ISearchProductModel } from "../../../models/OrderModel";
import { ResponseModel } from "../../../models/ResponseModel";

export function getList(params?: SearchModel) {
  return axios.get<PaginateModel<ImportRequestModel>>(`${ADMIN_IMPORT_REQUEST_ENDPOINT}`, {params})
}

export function getProductList(params: ISearchProductModel) {
  return axios.get(`${ADMIN_GET_CONSIGN_PRODUCTS_ENDPOINT}`, {params})
}

export function makeRequest(items: ImportRequestModel[], status: string, note: string | null) {
  return axios.post<ResponseModel>(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/manual-create`, {
    items: items,
    status,
    note
  })
}

export function getDetail(id?: string) {
  return axios.get<ResponseModel>(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/${id}`)
}

export function updateRequest(id: number, importRequest: ImportRequestModel, removeIds: number[], isConfirm: boolean) {
  return axios.post<ResponseModel>(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/${id}`, {
    import_request: importRequest,
    remove_ids: removeIds,
    is_confirm: isConfirm ? 1 : 0
  })
}

export function confirmRequest(ids: number[]) {
  return axios.post<ResponseModel>(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/confirm-done`, {request_ids: ids})
}


export function exportPdf(params: { id: number }) {
  return axios.post(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/export-pdf-landscape`, params)
}

export function exportDetails(id: number) {
  return axios.get(`${ADMIN_IMPORT_REQUEST_ENDPOINT}/export-details/${id}`, {responseType: 'blob'})
}
